import { isFloat, isInteger } from "../numbers";
import { commaToDotSeparator, whiteSpaceRemover } from "./string";

const frontEndLocale = "sv-SE";
const serviceLocale = "en-US";

const lang = {
	moneyToViewFormatError: "formatting error",
};

// Expects a valid number. Will return a money/currency format in use to Views.
export const moneyToViewFormat = (money: string | number | undefined | null) => {
	if (money === undefined || money === null) {
		return "";
	}
	let formatedMoneyValue = "";
	const moneyValue = new Intl.NumberFormat(frontEndLocale, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(Number(money));
	if (moneyValue.startsWith("−")) {
		// NumberFormat adds a dash instead of a minus symbol if the value is negative. Unacceptable.
		formatedMoneyValue = moneyValue.replace("−", "-");
	} else {
		formatedMoneyValue = moneyValue;
	}
	return formatedMoneyValue;
};

export const moneyToViewFormatForReservedAmount = (money: number | undefined) => {
	if (money === undefined) {
		return lang.moneyToViewFormatError;
	}
	return new Intl.NumberFormat(frontEndLocale, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(money * -1);
};

export const moneyToViewFormatWithoutDecimals = (money: string | number | undefined) => {
	if (money === undefined) {
		return lang.moneyToViewFormatError;
	}
	return new Intl.NumberFormat(frontEndLocale, {
		style: "currency",
		currency: "SEK",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(Number(money));
};

// Expects a valid number. Will add the correct amount of decimals(6)
export const stringToMoneyServiceFormat = (money: string) => {
	if (money === undefined) {
		return lang.moneyToViewFormatError;
	}
	// Using en-US in order to get dot(.) separator. Disabling grouping removes additional separators.
	const convertedMoney = new Intl.NumberFormat(serviceLocale, {
		useGrouping: false,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(Number(money));
	return convertedMoney;
};

// Will handle the form input value and transform it to a value containing 2 decimals.
export const transformToPaymentAmount = (value: string) => {
	const formatValue: string = commaToDotSeparator(value);
	if (isInteger(formatValue) || isFloat(formatValue)) {
		const transformedValue: string = commaToDotSeparator(
			stringToMoneyServiceFormat(whiteSpaceRemover(formatValue)),
		);

		return transformedValue;
	}
	return "";
};
